import { isClinician, isOnsiteProvider, isTelemedicineClinician } from 'user';

export function getCanViewClinicianScheduling(user) {
  return (
    isClinician(user) || isTelemedicineClinician(user) || isOnsiteProvider(user)
  );
}
